import React, { useEffect, useState, useRef, lazy, Component } from 'react';
import { ImageCarousel } from '../components/ImageCarousel';
import { AutoScrollCarousel } from '../components/AutoScrollCarousel';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { AboutAuthorSection } from '../components/AboutAuthorSection';
import { FAQSection } from '../components/FAQSection';
import { useCurrency } from '../components/CurrencyContext';
import { LazySection } from '../components/LazySection';
import { UrgencyCountdown } from '../components/UrgencyCountdown';
import { GuaranteeDropdown } from '../components/GuaranteeDropdown';
import { AmazonReviewsSection } from '../components/AmazonReviewsSection';
import { FloatingCTA } from '../components/FloatingCTA';
import { CheckCircle2, StarIcon, XCircle, X, Check, Volume2 as Volume2Icon, VolumeX as VolumeXIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://recetariosaludable.lat/cart/42439418740821:1?checkout';
const HIGH_PAYING_JOBS = [{
  src: 'https://cdn.magicpatterns.com/uploads/64nEYja2c7QzMD13KEvpgu/Tablero1-scaled.jpg',
  title: 'Tablero de control industrial',
  pay: 'Trabajo típico: $800 – $2,000'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5bRgMHd1xeswMGD1zgrbX2/Different-Electrical-Contactor-Types.webp',
  title: 'Control de motores trifásicos',
  pay: 'Trabajo típico: $500 – $1,500'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7tUpAbMa8HcPM2CAnRDcq1/WhatsApp-Image-2024-05-03-at-13.33.57-3-1024x617.jpg',
  title: 'Lectura de diagramas reales',
  pay: 'Aquí es donde la mayoría falla'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1N8faA7vriCLi4UeLQj348/hone-use-electrical-wire.jpg',
  title: 'Instalaciones que requieren precisión',
  pay: 'Errores aquí = dinero perdido'
}];
function HighPayingJobsCarousel() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCurrent(p => (p + 1) % HIGH_PAYING_JOBS.length);
    }, 3000);
    return () => clearInterval(id);
  }, []);
  return <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-4 mt-2" data-id="element-274">
      <h3 className="text-center text-[18px] md:text-[26px] font-black text-gray-900 mb-4 leading-tight font-[Poppins,_sans-serif] uppercase pt-[15px] pb-[15px]" data-id="element-275">
        👉 Estos son los trabajos donde realmente está el dinero
      </h3>
      <div className="relative overflow-hidden rounded-2xl" data-id="element-276">
        <div className="flex transition-transform duration-700 ease-in-out" style={{
        transform: `translateX(-${current * 100}%)`
      }} data-id="element-277">
          {HIGH_PAYING_JOBS.map((job, i) => <div key={i} className="flex-shrink-0 w-full px-1" data-id="element-278">
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.1)] border border-gray-200 overflow-hidden" data-id="element-279">
                <div className="px-4 py-3 bg-[#FFF8E1] border-b border-[#F0EBE0] text-center" data-id="element-280">
                  <p className="text-gray-900 font-bold text-[15px] md:text-[18px] leading-tight" data-id="element-281">
                    {job.title}
                  </p>
                  <p className="text-[#22C55E] font-black text-[14px] md:text-[16px] mt-1" data-id="element-282">
                    {job.pay}
                  </p>
                </div>
                <img src={job.src} alt={job.title} className="w-full h-56 md:h-72 object-cover" loading="lazy" data-id="element-283" />
              </div>
            </div>)}
        </div>
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-2 mt-3" data-id="element-284">
        {HIGH_PAYING_JOBS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-[#F5720E] scale-125' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a slide ${i + 1}`} data-id="element-285" />)}
      </div>
    </div>;
}
export function LandingPage() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const heroVideoRef = useRef<HTMLVideoElement>(null);
  const goToCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Manual de Controles Eléctricos + Guía Práctica',
        content_type: 'product',
        value: 14.99,
        currency: 'USD'
      });
    }
    window.open(CHECKOUT_URL, '_blank');
  };
  // Checkout sin disparar el evento InitiateCheckout (para botones no-naranja)
  const goToCheckoutNoTrack = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  // Scroll a la oferta final "Esto es todo lo que recibes hoy"
  const scrollToFinalOffer = () => {
    const el = document.getElementById('oferta-conviccion');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  // Direct checkout - no cart drawer
  const toggleMute = () => {
    if (heroVideoRef.current) {
      heroVideoRef.current.muted = !heroVideoRef.current.muted;
      setIsMuted(heroVideoRef.current.muted);
    }
  };
  return <div className="min-h-screen text-gray-900 font-inter selection:bg-orange-200 bg-[#FFFF] overflow-x-clip" data-id="element-286">
      {/* ANNOUNCEMENT BAR */}

      {/* PROBLEM & AGITATION SECTION */}
      <LazySection data-id="element-287">
        <section className="px-4 bg-white/80 pt-2 pb-6 md:pt-3 md:pb-8" data-id="element-288">
          <div className="max-w-2xl mx-auto space-y-6 md:space-y-8 pt-[0px] pb-[0px]" data-id="element-289">
            {/* HERO BLOCK — tightly grouped so section spacing doesn't separate these */}
            <div className="space-y-3" data-id="element-290">
              {/* Hero Headline */}
              <h1 className="text-center text-gray-900 uppercase tracking-tight md:text-[40px] px-2 font-[600] font-[Poppins,_sans-serif] text-[12px] pt-[10px] pb-[10px]" data-id="element-291">
                MÁS DE 370 DIAGRAMAS INDUSTRIALES EXPLICADOS PASO A PASO
              </h1>

              {/* Hero Subheadline */}
              <p className="text-center uppercase tracking-tight md:text-[26px] px-3 font-[Poppins,_sans-serif] font-[800] text-[20px] text-[#0F1827] leading-[1.2]" data-id="element-292">
                Aprende Controles Eléctricos y{' '}
                <span className="text-[#D02F06] underline decoration-[3px] underline-offset-2" data-id="element-293">
                  Deja de Perder Trabajos
                </span>{' '}
                por No Entender Diagramas
              </p>

              {/* Hero Image */}
              <div className="flex justify-center" data-id="element-294">
                <img src="https://cdn.magicpatterns.com/uploads/1YeXfp4JC434CwmTz9Ezek/ChatGPT_Image_May_6,_2026,_05_49_50_PM.png" alt="Sistema visual de controles eléctricos - diagramas, conexiones y tableros reales" className="w-full max-w-2xl rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.15)]" data-id="element-295" />
              </div>

              {/* AS SEEN ON Banner */}
              <div className="flex justify-center px-4 pt-2" data-id="element-296">
                <img src="https://cdn.magicpatterns.com/uploads/8Z2KQf7tcM1id8JPZVwozN/222222.png" alt="Visto en NBC, ABC, CBS, Fox News, USA Today y Digital Journal" className="w-full max-w-md" loading="lazy" data-id="element-297" />
              </div>
            </div>

            {/* Sales Letter Intro - Desde el escritorio de Energía Rentable */}
            <div id="para-ti-section" className="mt-4 mb-4 w-full max-w-2xl mx-auto px-2 md:px-4 pt-[0px] pb-[0px]" data-id="element-298">
              <div className="p-1 md:p-2" data-id="element-299">
                <p className="text-[13px] md:text-[14px] uppercase tracking-[0.15em] text-[#8E8E97] font-semibold mb-1 font-[Poppins,_sans-serif]" data-id="element-300">
                  Desde el escritorio deL INGENIERO Agustin Bermudez
                </p>
                <p className="text-[14px] md:text-[15px] text-gray-600 italic mb-5 font-[Poppins,_sans-serif]" data-id="element-301"></p>

                <p className="text-gray-900 font-bold md:text-[18px] mb-4 font-[Poppins,_sans-serif] text-[24px]" data-id="element-302">
                  Electricista,
                </p>

                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-303">
                  ¿Alguna vez te ha pasado esto?
                </p>

                <div className="border border-[#F0E6C8] rounded-3xl px-5 py-5 md:px-7 md:py-6 mb-4 bg-[#FFFFE9]" data-id="element-304">
                  <ul className="space-y-3 md:space-y-4" data-id="element-305">
                    {[<>
                        Ves un{' '}
                        <strong className="font-bold" data-id="element-306">
                          diagrama eléctrico
                        </strong>{' '}
                        y sientes que{' '}
                        <strong className="font-bold" data-id="element-307">
                          todo se ve confuso
                        </strong>
                        …
                      </>, <>
                        Te enfrentas a{' '}
                        <strong className="font-bold" data-id="element-308">
                          contactores, relés, temporizadores o motores
                          trifásicos
                        </strong>{' '}
                        y <em className="italic" data-id="element-309">no sabes por dónde empezar</em>
                        …
                      </>, <>
                        Has{' '}
                        <strong className="font-bold" data-id="element-310">evitado trabajos</strong>{' '}
                        porque no te sientes 100% seguro interpretando controles
                        eléctricos…
                      </>, <>
                        Sientes que{' '}
                        <strong className="font-bold" data-id="element-311">
                          otros electricistas cobran más
                        </strong>{' '}
                        porque entienden sistemas que tú todavía no dominas…
                      </>, <>
                        Has buscado videos, cursos o PDFs… pero sigues sintiendo
                        que falta una{' '}
                        <strong className="font-bold" data-id="element-312">
                          explicación clara, visual y práctica
                        </strong>
                        …
                      </>].map((item, i) => <li key={i} className="flex items-start gap-3.5" data-id="element-313">
                        <CheckCircle2 className="w-5 h-5 md:w-[22px] md:h-[22px] text-[#16A34A] flex-shrink-0 mt-1" strokeWidth={2.25} data-id="element-314" />
                        <span className="text-gray-600 text-[15px] md:text-[16px] leading-[1.65] font-normal" data-id="element-315">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-316"></p>

                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-317">
                  Y seamos honestos…
                </p>

                <p className="text-gray-900 text-[16px] md:text-[18px] leading-relaxed mb-4 font-bold font-[Poppins,_sans-serif]" data-id="element-318">
                  Los controles eléctricos NO deberían sentirse tan complicados.
                </p>

                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-319">
                  Si tú quieres entender diagramas, montar controles y trabajar
                  con más seguridad…
                </p>

                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-320">
                  En vez de pasar meses viendo videos desordenados, copiando
                  conexiones sin entenderlas o dependiendo siempre de otro
                  electricista…
                </p>

                <div className="border-l-4 border-[#F5720E] rounded-r-lg px-4 py-3 bg-[#FFFFE9] pt-[15px] pb-[15px]" data-id="element-321">
                  <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed font-semibold font-[Poppins,_sans-serif]" data-id="element-322">
                    Entonces esta puede ser una de las páginas más importantes
                    que lees hoy.
                  </p>
                </div>
              </div>
            </div>

            {/* GRAN PROBLEMA - Por qué el contenido típico no funciona */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-3 mt-3 pt-[0px] pb-[0px]" data-id="element-323">
              {/* Headline destacado en banner oscuro (como la referencia) */}
              <div className="bg-[#0F1827] rounded-2xl px-6 py-8 md:py-10 mb-4 shadow-[0_4px_20px_rgba(0,0,0,0.08)] pt-[10px] pb-[10px]" data-id="element-324">
                <h2 className="text-center font-black text-[28px] md:text-[40px] leading-tight font-[Poppins,_sans-serif] text-white" data-id="element-325">
                  "Aquí está el{' '}
                  <span className="text-[#F7D060]" data-id="element-326">GRAN problema</span>…"
                </h2>
              </div>

              {/* Cuerpo del texto FUERA de la caja, sobre fondo limpio */}
              <div className="px-2 md:px-4" data-id="element-327">
                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-328">
                  Cuando buscas aprender controles eléctricos, normalmente
                  encuentras una de estas cosas:
                </p>

                <p className="text-[18px] md:text-[20px] leading-snug font-bold font-[Poppins,_sans-serif] uppercase mb-5 text-[#D02F06]" data-id="element-329">
                  La mayoría del contenido de electricidad en internet es{' '}
                  <span className="underline decoration-2 underline-offset-2" data-id="element-330">
                    COMPLETA BASURA.
                  </span>
                </p>

                <p className="text-gray-700 md:text-[17px] mb-4 font-semibold text-[20px]" data-id="element-331">
                  Aquí está el porqué:
                </p>

                <div className="border border-[#F0E6C8] rounded-3xl px-5 py-5 md:px-7 md:py-6 mb-4 bg-[#FFFFE9]" data-id="element-332">
                  <ul className="space-y-3 md:space-y-4" data-id="element-333">
                    {['Videos que enseñan conexiones… pero no la lógica real.', 'Cursos llenos de teoría y poca práctica real.', 'Diagramas confusos que parecen imposibles de interpretar.', 'Explicaciones que se saltan pasos importantes.', 'Contenido desordenado que te hace perder tiempo y dinero.'].map((item, i) => <li key={i} className="flex items-start gap-3.5" data-id="element-334">
                        <XCircle className="w-5 h-5 md:w-[22px] md:h-[22px] text-[#DC2626] flex-shrink-0 mt-1" strokeWidth={2.25} data-id="element-335" />
                        <span className="text-gray-600 text-[15px] md:text-[16px] leading-[1.65] font-normal" data-id="element-336">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-337">
                  Y en muchos casos…
                </p>

                <p className="text-gray-900 font-black text-[16px] md:text-[18px] leading-relaxed mb-4 font-[Poppins,_sans-serif] uppercase" data-id="element-338">
                  Simplemente NO hay suficiente detalle.
                </p>

                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed" data-id="element-339">
                  Por eso tantos electricistas sienten que los controles
                  eléctricos son{' '}
                  <span className="font-bold text-gray-900" data-id="element-340">
                    más difíciles de lo que realmente deberían ser.
                  </span>
                </p>
              </div>
            </div>

            {/* SOLUTION INTRO - Por eso decidimos resolver todo eso */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-3 mt-3" data-id="element-341">
              {/* Intro paragraph fuera de la caja */}
              <p className="md:text-[19px] mb-4 px-2 md:px-4 pt-[10px] pb-[10px] text-[24px] font-[800] text-center font-[Poppins,_sans-serif]" data-id="element-342">
                <span className="relative inline-block px-3 py-1" data-id="element-343">
                  <span className="absolute inset-0 bg-[#FEF08A] -rotate-1 rounded-md shadow-[0_2px_8px_rgba(0,0,0,0.08)]" aria-hidden="true" data-id="element-344"></span>
                  <span className="relative text-gray-900" data-id="element-345">
                    Por eso decidimos resolver todo eso…
                  </span>
                </span>
              </p>

              <div data-id="element-346">
                {/* Orange brand banner — Ted's Woodworking style */}

                {/* Presentando + Product Name */}
                <div className="text-center pt-3 pb-2" data-id="element-347">
                  <p className="text-[13px] md:text-[15px] uppercase tracking-[0.25em] text-[#8E8E97] font-semibold mb-2 font-[Poppins,_sans-serif]" data-id="element-348">
                    Presentando…
                  </p>
                  <h3 className="font-[Poppins,_sans-serif] uppercase leading-[0.95] tracking-tight" data-id="element-349">
                    <span className="block text-[40px] md:text-[68px] font-black text-[#0F1827] drop-shadow-[0_2px_0_rgba(245,114,14,0.15)]" data-id="element-350">
                      Comandos
                    </span>
                    <span className="inline-flex items-center gap-3 mt-1" data-id="element-351">
                      <span className="h-[2px] w-8 md:w-14 bg-[#F5720E]" aria-hidden="true" data-id="element-352"></span>
                      <span className="text-[28px] md:text-[44px] font-extrabold italic text-[#F5720E] tracking-wide" data-id="element-353">
                        Eléctricos
                      </span>
                      <span className="h-[2px] w-8 md:w-14 bg-[#F5720E]" aria-hidden="true" data-id="element-354"></span>
                    </span>
                    <span className="block mt-3" data-id="element-355">
                      <span className="relative inline-block px-5 py-1.5 bg-[#0F1827] text-[#FBBF24] text-[26px] md:text-[40px] font-black tracking-[0.25em] rounded-md shadow-[0_8px_24px_rgba(15,24,39,0.35)] border-2 border-[#FBBF24]" data-id="element-356">
                        <span className="absolute -top-2 -right-2 w-4 h-4 md:w-5 md:h-5 bg-[#F5720E] rounded-full shadow-[0_0_12px_rgba(245,114,14,0.8)]" aria-hidden="true" data-id="element-357"></span>
                        PRO
                      </span>
                    </span>
                  </h3>
                  <p className="mt-4 text-[11px] md:text-[13px] tracking-[0.4em] text-[#8E8E97] font-bold uppercase" data-id="element-358">
                    El Sistema Definitivo
                  </p>
                </div>

                {/* Clean product image — no decorations */}
                <div className="flex justify-center px-2 pt-2 pb-4 bg-white mt-[10px] mb-[10px] ml-[0px] mr-[0px]" data-id="element-359">
                  <img src="https://cdn.magicpatterns.com/uploads/dmH2kUttanHHkjGd1mkgMg/ChatGPT_Image_May_6,_2026,_07_09_23_PM.png" alt="Comandos Eléctricos PRO - Guía Práctica de Controles Eléctricos" className="w-full max-w-md" loading="lazy" data-id="element-360" />
                </div>

                {/* Big bold headline + italic subline */}
                <div className="px-2 md:px-4" data-id="element-361">
                  <h4 className="text-center text-[#0F1827] font-semibold md:text-[38px] mb-4 font-[Poppins,_sans-serif] tracking-tight text-[22px] leading-[1.15]" data-id="element-362">
                    Domina{' '}
                    <span className="font-bold italic text-[#F5720E]" data-id="element-363">
                      +370 diagramas
                    </span>
                    <br className="hidden md:block" data-id="element-364" /> con explicaciones paso a
                    paso
                  </h4>

                  <p className="text-center text-gray-800 md:text-[26px] italic mb-5 font-[Poppins,_sans-serif] text-[14px] font-[400]" data-id="element-365">
                    …aunque hoy te sientas perdido con los controles eléctricos.
                  </p>

                  {/* Body copy — clean, generous spacing, like Ted's */}
                  <div className="space-y-5 text-gray-900 text-[16px] md:text-[18px] leading-[1.7] font-[Poppins,_sans-serif]" data-id="element-366">
                    <p data-id="element-367">
                      ¿Qué hace que un material de controles eléctricos sea
                      "perfecto"?
                    </p>

                    <p data-id="element-368">
                      Sencillo: debe ser lo suficientemente{' '}
                      <span className="underline decoration-2 underline-offset-2" data-id="element-369">
                        detallado para no dejar nada a la adivinanza
                      </span>{' '}
                      pero{' '}
                      <strong className="font-extrabold" data-id="element-370">
                        lo suficientemente claro para principiantes.
                      </strong>{' '}
                      Debe contener instrucciones completas de inicio a fin.
                    </p>

                    <p data-id="element-371">
                      Mira las características y{' '}
                      <strong className="font-extrabold bg-[#FFEE8C] box-decoration-clone px-1 py-0.5" data-id="element-372">
                        descubre por qué esta guía es 10x mejor
                      </strong>{' '}
                      que cualquier curso o video genérico que encontrarás por
                      ahí:
                    </p>
                  </div>

                  {/* Includes — minimal cream box, no emojis, no gradients */}
                  <div className="mt-5 bg-[#FFFBEB] border border-[#F0E6C8] rounded-lg px-6 py-6 md:px-8 md:py-7 pt-[10px] pb-[10px]" data-id="element-373">
                    <p className="text-gray-900 font-bold text-[15px] md:text-[16px] mb-4 italic font-[Poppins,_sans-serif]" data-id="element-374">
                      Incluye:
                    </p>
                    <ul className="space-y-2.5" data-id="element-375">
                      {['Diagramas de fuerza detallados', 'Conexiones realistas paso a paso', 'Motores monofásicos y trifásicos', 'Contactores, relés y temporizadores', 'Sensores y señalización', 'Sistemas eléctricos industriales aplicados'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-900 text-[15px] md:text-[16px] leading-snug" data-id="element-376">
                          <span className="text-gray-900 font-bold flex-shrink-0 mt-0.5" data-id="element-377">
                            •
                          </span>
                          <span data-id="element-378">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* BRIDGE / CONVICTION SECTION */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-3 mt-3" data-id="element-379"></div>

            <div className="text-center mb-3 px-2" data-id="element-380"></div>

            {/* 👇 MIRA ESTO… heading */}
            <h3 className="text-center text-[22px] md:text-[30px] font-black text-gray-900 mt-6 mb-3 leading-tight font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-381"></h3>

            {/* AUTO-SCROLLING IMAGE CAROUSEL - above "¿Qué hace que este sistema sea diferente?" */}
            <AutoScrollCarousel data-id="element-382" />

            {/* DIFFERENTIATION SECTION - ¿Qué hace que este sistema sea diferente? */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mb-3 mt-3" data-id="element-383">
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-384">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-385">
                  ¿Qué hace que este sistema sea diferente?
                </h3>

                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-386">
                  Un buen material de controles eléctricos debe tener{' '}
                  <span className="font-bold text-gray-800" data-id="element-387">dos cosas</span>:
                </p>

                <div className="space-y-3 mb-5" data-id="element-388">
                  <div className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-389">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#F5720E] text-white font-black text-[14px] flex items-center justify-center" data-id="element-390">
                      1
                    </div>
                    <p className="text-gray-600 text-[15px] md:text-[16px] leading-relaxed pt-1" data-id="element-391">
                      Debe ser lo suficientemente{' '}
                      <span className="font-bold text-gray-800" data-id="element-392">detallado</span>{' '}
                      para que no tengas que adivinar…
                    </p>
                  </div>

                  <div className="flex items-start gap-3 bg-white border border-[#F0EBE0] rounded-xl px-4 py-3" data-id="element-393">
                    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#22C55E] text-white font-black text-[14px] flex items-center justify-center" data-id="element-394">
                      2
                    </div>
                    <p className="text-gray-600 text-[15px] md:text-[16px] leading-relaxed pt-1" data-id="element-395">
                      Pero lo suficientemente{' '}
                      <span className="font-bold text-gray-800" data-id="element-396">claro</span>{' '}
                      para que puedas entenderlo sin ahogarte en teoría.
                    </p>
                  </div>
                </div>

                <div className="border-l-4 border-[#F5720E] bg-[#FFF8E1] rounded-r-lg px-4 py-3" data-id="element-397">
                  <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed font-semibold font-[Poppins,_sans-serif]" data-id="element-398">
                    👇 Mira por qué este sistema es diferente a los cursos
                    genéricos y videos sueltos:
                  </p>
                </div>
              </div>
            </div>

            {/* === FEATURES SECTION (moved here, below diferente box) === */}
            <div className="my-4 bg-white py-6 md:py-8 px-4 pt-[0px] pb-[0px]" data-id="element-399">
              <div className="max-w-4xl mx-auto" data-id="element-400">
                {/* Imagen de tablero eléctrico - vista interior */}
                <div className="w-full max-w-2xl mx-auto mb-5 flex justify-center" data-id="element-401">
                  <img src="https://cdn.magicpatterns.com/uploads/u58Yn2mrLo1vV2WYJHrGrK/ChatGPT_Image_May_6,_2026,_05_40_35_PM.png" alt="Tablero eléctrico completo - vista interior con componentes identificados" className="w-full max-w-2xl rounded-xl" loading="lazy" data-id="element-402" />
                </div>
                <p className="text-center text-[#D9A441]/70 tracking-widest uppercase mb-3 text-[14px] md:text-[16px] font-bold" data-id="element-403">
                  POR QUÉ ESTE SISTEMA ES DIFERENTE
                </p>
                <h2 className="text-center text-[26px] md:text-[38px] font-black text-[#0F1827] mb-6 leading-tight font-[Poppins,_sans-serif]" data-id="element-404">
                  5 RAZONES POR LAS QUE ESTO FUNCIONA
                </h2>
                <p className="text-center text-sm md:text-base mb-6 max-w-2xl mx-auto text-[#040404] pt-[0px] pb-[0px]" data-id="element-405">
                  No es otro curso genérico. Es un sistema visual diseñado para
                  que entiendas, apliques y avances de verdad.
                </p>

                <div className="space-y-5 max-w-3xl mx-auto" data-id="element-406">
                  {/* FEATURE 01 */}
                  <div className="text-center bg-[#FFF6DC] rounded-2xl p-5 md:p-7 border-2 border-dashed border-[#C9B98A]" data-id="element-407">
                    <h3 className="text-[32px] md:text-[44px] font-black text-[#0F1827] mb-1 leading-tight font-[Poppins,_sans-serif]" data-id="element-408">
                      <span className="inline-block border-b-4 border-[#0F1827] pb-1" data-id="element-409">
                        Feature #1:
                      </span>
                    </h3>
                    <h4 className="md:text-[40px] font-bold text-[#2C5F7D] mb-8 font-[Poppins,_sans-serif] text-[20px]" data-id="element-410">
                      Diagramas explicados paso a paso
                    </h4>
                    <div className="flex justify-center mb-5" data-id="element-411">
                      <img src="https://cdn.magicpatterns.com/uploads/t7uu9R1ZkxzubGTh4cy2ju/ChatGPT_Image_May_6,_2026,_07_13_48_PM.png" alt="Dimensionamiento y Cotización de Motores Eléctricos" className="w-full max-w-md rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-412" />
                    </div>
                    <div className="text-left max-w-2xl mx-auto space-y-4" data-id="element-413">
                      <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-414">
                        No son imágenes sueltas. Cada diagrama te muestra:
                      </p>
                      {[{
                      text: 'Qué hace cada componente',
                      bold: 'cada componente'
                    }, {
                      text: 'Cómo se conecta',
                      bold: 'Cómo se conecta'
                    }, {
                      text: 'Por qué se conecta así',
                      bold: 'Por qué'
                    }, {
                      text: 'Su función en el circuito',
                      bold: 'función'
                    }, {
                      text: 'Cómo encaja en el sistema',
                      bold: 'Cómo encaja'
                    }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-415">
                          <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-416" />
                          <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-417">
                            {item.text.split(item.bold)[0]}
                            <strong className="font-bold" data-id="element-418">{item.bold}</strong>
                            {item.text.split(item.bold)[1]}
                          </p>
                        </div>)}
                      <p className="text-gray-600 text-sm md:text-base italic mt-6 pl-11" data-id="element-419">
                        Como tener una guía visual al lado mientras aprendes.
                      </p>
                    </div>
                  </div>

                  {/* FEATURE 02 */}
                  <div className="text-center bg-[#FFF6DC] rounded-2xl p-5 md:p-7 border-2 border-dashed border-[#C9B98A]" data-id="element-420">
                    <h3 className="text-[32px] md:text-[44px] font-black text-[#0F1827] mb-1 leading-tight font-[Poppins,_sans-serif]" data-id="element-421">
                      <span className="inline-block border-b-4 border-[#0F1827] pb-1" data-id="element-422">
                        Feature #2:
                      </span>
                    </h3>
                    <h4 className="md:text-[40px] font-bold text-[#2C5F7D] mb-8 font-[Poppins,_sans-serif] text-[20px]" data-id="element-423">
                      Diagramas de fuerza y control
                    </h4>
                    <div className="flex justify-center mb-5" data-id="element-424">
                      <img src="https://cdn.magicpatterns.com/uploads/tUjvpWhk7xuTFhpDn9MuBN/vNSeg6K_(1).png" alt="Lección en video incluida - Diagramas de fuerza y control" className="w-full max-w-md rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-425" />
                    </div>
                    <div className="text-left max-w-2xl mx-auto space-y-4" data-id="element-426">
                      <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-427">
                        Aprende a separar lo que muchos confunden:
                      </p>
                      {['Circuito de fuerza', 'Circuito de control', 'Conexión realista', 'Símbolos eléctricos', 'Componentes físicos'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-428">
                          <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-429" />
                          <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-430">
                            <strong className="font-bold" data-id="element-431">{item}</strong>
                          </p>
                        </div>)}
                      <p className="text-gray-600 text-sm md:text-base italic mt-6 pl-11" data-id="element-432">
                        Conecta el papel con la vida real.
                      </p>
                    </div>
                  </div>

                  {/* FEATURE 03 */}
                  <div className="text-center bg-[#FFF6DC] rounded-2xl p-5 md:p-7 border-2 border-dashed border-[#C9B98A]" data-id="element-433">
                    <h3 className="text-[32px] md:text-[44px] font-black text-[#0F1827] mb-1 leading-tight font-[Poppins,_sans-serif]" data-id="element-434">
                      <span className="inline-block border-b-4 border-[#0F1827] pb-1" data-id="element-435">
                        Feature #3:
                      </span>
                    </h3>
                    <h4 className="md:text-[40px] font-bold text-[#2C5F7D] mb-8 font-[Poppins,_sans-serif] text-[20px]" data-id="element-436">
                      Conexiones realistas y aplicaciones industriales
                    </h4>
                    <div className="flex justify-center mb-5" data-id="element-437">
                      <img src="https://cdn.magicpatterns.com/uploads/c4fF1oeESw81k3XoutEiQZ/ChatGPT_Image_May_6,_2026,_07_10_57_PM.png" alt="Plantilla - Informe mensual de ingresos brutos" className="w-full max-w-md rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] bg-[#FFF7DC]" loading="lazy" data-id="element-438" />
                    </div>
                    <div className="text-left max-w-2xl mx-auto space-y-4" data-id="element-439">
                      <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-440">
                        Nada de pura teoría. Aplicaciones reales como:
                      </p>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-441">
                        {['Arranques de motores', 'Control trifásico y monofásico', 'Contactores y relés térmicos', 'Temporizadores y sensores', 'Tableros de control industriales'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-442">
                            <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-443" />
                            <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-444">
                              <strong className="font-bold" data-id="element-445">{item}</strong>
                            </p>
                          </div>)}
                      </div>
                      <p className="text-gray-600 text-sm md:text-base italic mt-6 pl-11" data-id="element-446">
                        Aprendizaje visual, práctico y aplicable.
                      </p>
                    </div>
                  </div>

                  {/* FEATURE 04 */}
                  <div className="text-center bg-[#FFF6DC] rounded-2xl p-5 md:p-7 border-2 border-dashed border-[#C9B98A]" data-id="element-447">
                    <h3 className="text-[32px] md:text-[44px] font-black text-[#0F1827] mb-1 leading-tight font-[Poppins,_sans-serif]" data-id="element-448">
                      <span className="inline-block border-b-4 border-[#0F1827] pb-1" data-id="element-449">
                        Feature #4:
                      </span>
                    </h3>
                    <h4 className="md:text-[40px] font-bold text-[#2C5F7D] mb-8 font-[Poppins,_sans-serif] text-[20px]" data-id="element-450">
                      Sin adivinar conexiones
                    </h4>
                    <div className="flex justify-center mb-5" data-id="element-451">
                      <img src="https://cdn.magicpatterns.com/uploads/3jZNKNDSDsCZ7z26wbE21U/ChatGPT_Image_6_may_2026,_05_09_24_p.m..png" alt="Sin adivinar conexiones - Entiende cada parte del circuito con diagramas claros" className="w-full max-w-md rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-452" />
                    </div>
                    <div className="text-left max-w-2xl mx-auto space-y-4" data-id="element-453">
                      <p className="text-gray-800 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-454">
                        Con{' '}
                        <strong className="font-bold" data-id="element-455">diagramas claros</strong>,
                        dejas de adivinar qué cable va dónde.
                      </p>
                      <div className="flex items-start gap-4" data-id="element-456">
                        <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-457" />
                        <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-458">
                          Todo empieza a{' '}
                          <strong className="font-bold" data-id="element-459">tener sentido</strong>.
                        </p>
                      </div>
                      <div className="flex items-start gap-4" data-id="element-460">
                        <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-461" />
                        <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-462">
                          Las piezas{' '}
                          <strong className="font-bold" data-id="element-463">encajan</strong>.
                        </p>
                      </div>
                      <div className="flex items-start gap-4" data-id="element-464">
                        <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-465" />
                        <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-466">
                          Lo complicado{' '}
                          <strong className="font-bold" data-id="element-467">
                            se vuelve lógico
                          </strong>
                          .
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* FEATURE 05 */}
                  <div className="text-center bg-[#FFF6DC] rounded-2xl p-5 md:p-7 border-2 border-dashed border-[#C9B98A]" data-id="element-468">
                    <h3 className="text-[32px] md:text-[44px] font-black text-[#0F1827] mb-1 leading-tight font-[Poppins,_sans-serif]" data-id="element-469">
                      <span className="inline-block border-b-4 border-[#0F1827] pb-1" data-id="element-470">
                        Feature #5:
                      </span>
                    </h3>
                    <h4 className="md:text-[40px] font-bold text-[#2C5F7D] mb-8 font-[Poppins,_sans-serif] text-[20px]" data-id="element-471">
                      Diseñado para principiantes, técnicos y electricistas con
                      experiencia
                    </h4>
                    <div className="flex justify-center mb-5" data-id="element-472">
                      <img src="https://cdn.magicpatterns.com/uploads/jEAN4XmBk4tMr1vi4gG2U2/ChatGPT_Image_6_may_2026,_05_11_19_p.m..png" alt="Diseñado para principiantes, técnicos y electricistas con experiencia" className="w-full max-w-md rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" loading="lazy" data-id="element-473" />
                    </div>
                    <div className="text-left max-w-2xl mx-auto space-y-4" data-id="element-474">
                      <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed mb-4 font-semibold" data-id="element-475">
                        No necesitas:
                      </p>
                      {['Ser ingeniero', 'Saber automatización avanzada', 'Años de experiencia'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-476">
                          <X className="w-7 h-7 text-[#DC2626] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-477" />
                          <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-478">
                            {item}
                          </p>
                        </div>)}
                      <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed mt-6 mb-4 font-semibold" data-id="element-479">
                        Es para ti si:
                      </p>
                      {['Estás empezando', 'Eres electricista residencial y quieres subir de nivel', 'Estudias electricidad', 'Ya trabajas, pero te falta seguridad', 'Quieres entender controles de forma práctica'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-480">
                          <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-481" />
                          <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed" data-id="element-482">
                            <strong className="font-bold" data-id="element-483">{item}</strong>
                          </p>
                        </div>)}
                    </div>
                  </div>
                </div>

                {/* +370 PAGES SUMMARY - adapted to light theme */}

                {/* CTA */}
                <div className="mt-5 text-center max-w-xl mx-auto" data-id="element-484">
                  <button onClick={scrollToFinalOffer} className="green-cta-impact w-full max-w-md mx-auto text-white font-black py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55E] font-[Roboto,_sans-serif] flex flex-col items-center gap-1" data-id="element-485">
                    <span className="text-[18px] md:text-[20px] uppercase tracking-wide" data-id="element-486">
                      SÍ, QUIERO ACCESO INMEDIATO
                    </span>
                    <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-487">
                      Acceso Inmediato • Garantía de 7 Días
                    </span>
                  </button>
                  <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-488">
                    Acceso inmediato • Sin complicaciones • Todo en un solo
                    lugar
                  </p>
                </div>
              </div>
            </div>

            {/* === SALTO PROFESIONAL + NO IMPORTA SI TE SIENTES PERDIDO === */}
            <div className="w-full max-w-2xl mx-auto px-2 md:px-4 mt-4 mb-3 space-y-4" data-id="element-489">
              {/* SALTO PROFESIONAL */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-490">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[28px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-491">
                  Los trabajos mejor pagados normalmente requieren esto
                </h3>
                <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3 font-semibold" data-id="element-492">
                  Seamos directos:
                </p>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-493">
                  Muchos electricistas se quedan haciendo trabajos básicos
                  porque nunca dieron el salto a entender controles eléctricos.
                </p>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-494">
                  Y los controles eléctricos son una habilidad que puede
                  ayudarte a verte más profesional, aceptar trabajos más
                  avanzados y sentirte más seguro frente a sistemas reales.
                </p>
                <div className="border-l-4 border-[#F5720E] bg-[#FFF8E1] rounded-r-lg px-4 py-3" data-id="element-495">
                  <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed font-[Poppins,_sans-serif]" data-id="element-496">
                    Porque un electricista que entiende diagramas…
                  </p>
                  <p className="text-gray-900 text-[15px] md:text-[17px] leading-relaxed font-bold mt-1 font-[Poppins,_sans-serif]" data-id="element-497">
                    No trabaja igual que uno que solo copia conexiones.
                  </p>
                </div>
              </div>

              {/* NO IMPORTA SI TE SIENTES PERDIDO */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-498">
                <h3 className="text-gray-900 font-black text-[20px] md:text-[26px] leading-tight mb-4 font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-499">
                  No importa si ahora te sientes perdido
                </h3>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-500">
                  Tal vez piensas:
                </p>
                <div className="bg-gray-100 border-l-4 border-gray-400 rounded-r-lg px-4 py-3 mb-4" data-id="element-501">
                  <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed italic" data-id="element-502">
                    Esto es muy avanzado para mí…
                  </p>
                </div>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-503">
                  Pero la verdad es que muchas veces{' '}
                  <span className="font-bold text-gray-800" data-id="element-504">
                    el problema no eres tú
                  </span>
                  .
                </p>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-505">
                  El problema es que nadie te lo explicó de forma clara.
                </p>
                <p className="text-gray-600 text-[15px] md:text-[17px] leading-relaxed mb-3" data-id="element-506">
                  La mayoría del contenido te tira teoría encima.
                </p>
                <p className="text-gray-800 text-[16px] md:text-[18px] leading-relaxed font-bold font-[Poppins,_sans-serif]" data-id="element-507">
                  Este sistema te muestra el contenido de forma visual, práctica
                  y ordenada. Paso a paso.
                </p>
              </div>

              {/* IMAGE CAROUSEL - vista previa */}
              <ImageCarousel data-id="element-508" />

              {/* ESTO ES TODO LO QUE RECIBES HOY - VALUE STACK (Ted's Woodworking style) */}
              <div className="relative bg-[#FFF6DC] border-2 border-dashed border-[#C9B98A] rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-509">
                {/* Brand-aligned banner header — cream + orange */}
                <div className="relative bg-[#FFFBEB] px-5 py-6 md:px-8 md:py-7 text-center border-b-2 border-dashed border-[#C9B98A]" data-id="element-510">
                  <p className="text-[#F5720E] text-[11px] md:text-[13px] uppercase tracking-[0.3em] font-black mb-2 font-[Poppins,_sans-serif] flex items-center justify-center gap-2" data-id="element-511">
                    <span className="h-px w-8 bg-[#F5720E]" aria-hidden="true" data-id="element-512"></span>
                    Resumen completo del paquete
                    <span className="h-px w-8 bg-[#F5720E]" aria-hidden="true" data-id="element-513"></span>
                  </p>
                  <h3 className="text-[#0F1827] font-black text-[22px] md:text-[34px] leading-[1.05] font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-514">
                    Aquí está{' '}
                    <span className="relative inline-block" data-id="element-515">
                      <span className="absolute inset-x-0 bottom-1 h-3 md:h-4 bg-[#FBBF24]/60 -rotate-1 rounded-sm" aria-hidden="true" data-id="element-516"></span>
                      <span className="relative text-[#F5720E]" data-id="element-517">todo</span>
                    </span>{' '}
                    lo que recibes hoy
                  </h3>
                  <p className="text-gray-600 text-[12px] md:text-[14px] mt-2.5 italic font-[Poppins,_sans-serif]" data-id="element-518">
                    Acceso inmediato — directo a tu correo
                  </p>
                </div>

                <div className="p-5 md:p-8" data-id="element-519">
                  <ul className="space-y-3 md:space-y-4" data-id="element-520">
                    {[{
                    n: '01',
                    title: 'Guía Práctica de Controles Eléctricos',
                    desc: 'Más de 370 páginas visuales con diagramas, conexiones y sistemas explicados paso a paso.',
                    value: '$97'
                  }, {
                    n: '02',
                    title: 'Diagramas de fuerza y control',
                    desc: 'Para entender cómo funciona cada sistema desde la lógica eléctrica.',
                    value: '$47'
                  }, {
                    n: '03',
                    title: 'Conexiones realistas',
                    desc: 'Para ver cómo se aplica el diagrama en componentes reales.',
                    value: '$37'
                  }, {
                    n: '04',
                    title: 'Ejemplos de motores, contactores, relés y temporizadores',
                    desc: 'Para estudiar sistemas que se usan en trabajos reales.',
                    value: '$47'
                  }, {
                    n: '05',
                    title: 'Acceso inmediato digital',
                    desc: 'Puedes empezar a revisar el material desde tu celular, tablet o computadora.',
                    value: '$27'
                  }].map((item, i) => <li key={i} className="relative bg-white border-2 border-[#E5D9B0] rounded-xl px-4 py-4 md:px-5 md:py-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)]" data-id="element-521">
                        <div className="flex items-start gap-3 md:gap-4" data-id="element-522">
                          {/* Number badge */}
                          <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-[#0F1827] text-[#FBBF24] font-black text-[15px] md:text-[18px] flex items-center justify-center font-[Poppins,_sans-serif] shadow-[0_2px_6px_rgba(0,0,0,0.2)]" data-id="element-523">
                            {item.n}
                          </div>

                          <div className="flex-1 min-w-0" data-id="element-524">
                            {/* Title row with check + included tag */}
                            <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-525">
                              <CheckCircle2 className="w-[18px] h-[18px] text-[#22C55E] flex-shrink-0" strokeWidth={2.5} data-id="element-526" />
                              <span className="inline-block bg-[#22C55E] text-white text-[9px] md:text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-sm" data-id="element-527">
                                Incluido
                              </span>
                            </div>

                            <p className="text-[#0F1827] font-black text-[15px] md:text-[17px] leading-snug font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-528">
                              {item.title}
                            </p>
                            <p className="text-gray-700 text-[13px] md:text-[14px] leading-relaxed mt-1.5" data-id="element-529">
                              {item.desc}
                            </p>

                            {/* Value row — retail price right aligned, struck through */}
                            <div className="flex items-center justify-between mt-3 pt-3 border-t border-dashed border-[#E5D9B0]" data-id="element-530">
                              <span className="text-[10px] md:text-[11px] uppercase tracking-[0.15em] font-bold text-gray-500" data-id="element-531">
                                Valor real
                              </span>
                              <div className="flex items-baseline gap-2" data-id="element-532">
                                <span className="text-gray-400 line-through decoration-[#DC2626] decoration-2 font-bold text-[15px] md:text-[17px] font-[Poppins,_sans-serif]" data-id="element-533">
                                  {item.value}
                                </span>
                                <span className="bg-[#FEF08A] text-[#0F1827] text-[10px] md:text-[11px] font-black px-2 py-0.5 rounded-sm uppercase tracking-wide" data-id="element-534">
                                  Gratis
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>)}
                  </ul>

                  {/* TOTAL VALUE BOX — Ted's signature finale */}
                  <div className="mt-6 bg-[#0F1827] rounded-xl p-5 md:p-6 border-2 border-[#F5720E] shadow-[0_6px_24px_rgba(15,24,39,0.25)]" data-id="element-535">
                    <div className="flex items-center justify-between mb-3 pb-3 border-b border-dashed border-white/20" data-id="element-536">
                      <span className="text-gray-300 text-[12px] md:text-[14px] uppercase tracking-[0.15em] font-bold" data-id="element-537">
                        Valor total real
                      </span>
                      <span className="text-gray-400 line-through decoration-[#DC2626] decoration-[3px] font-black text-[22px] md:text-[28px] font-[Poppins,_sans-serif]" data-id="element-538">
                        $255
                      </span>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-539">
                      <div className="flex flex-col" data-id="element-540">
                        <span className="text-[#FBBF24] text-[11px] md:text-[13px] uppercase tracking-[0.2em] font-black" data-id="element-541">
                          Hoy solo pagas
                        </span>
                        <span className="text-gray-400 text-[10px] md:text-[11px] italic mt-0.5" data-id="element-542">
                          Pago único — sin suscripciones
                        </span>
                      </div>
                      <div className="flex items-baseline gap-1.5" data-id="element-543">
                        <span className="text-[#22C55E] font-black text-[36px] md:text-[48px] leading-none font-[Poppins,_sans-serif] drop-shadow-[0_2px_8px_rgba(34,197,94,0.35)]" data-id="element-544">
                          $14.99
                        </span>
                      </div>
                    </div>

                    {/* Savings stamp - clickable CTA */}
                    <div className="mt-4 flex justify-center" data-id="element-545">
                      <button type="button" onClick={goToCheckout} aria-label="Aprovechar oferta - Ahorras más de $240 hoy" className="group bg-[#F5720E] hover:bg-[#E0660A] active:scale-95 text-white font-black md:text-[14px] uppercase tracking-wider px-4 py-1.5 rounded-md -rotate-2 shadow-[0_4px_12px_rgba(245,114,14,0.4)] hover:shadow-[0_6px_18px_rgba(245,114,14,0.55)] border-2 border-white/20 transition-all duration-200 cursor-pointer animate-pulse hover:animate-none focus:outline-none focus:ring-2 focus:ring-[#F5720E]/50 focus:ring-offset-2 text-[20px]" data-id="element-546">
                        SÍ, QUIERO ACCESO INMEDIATO
                      </button>
                    </div>
                  </div>

                  {/* Urgency footer */}
                  <p className="text-center text-[12px] md:text-[14px] text-[#7F1D1D] font-bold italic mt-4 font-[Poppins,_sans-serif]" data-id="element-547">
                    ⏳ Esta oferta solo está disponible en esta página
                  </p>
                </div>
              </div>

              {/* BONOS + PRICE REVEAL + CTA */}
              <div className="bg-[#FFFDF7] border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)]" data-id="element-548">
                <h3 className="text-gray-900 text-[20px] md:text-[28px] leading-tight mb-5 font-[Poppins,_sans-serif] uppercase tracking-tight font-[700]" data-id="element-549">
                  ADEMÁS… SI ACCEDES HOY, DESBLOQUEAS ESTOS BONOS EXCLUSIVOS
                  GRATIS
                </h3>

                <ul className="space-y-5 mb-6" data-id="element-550">
                  {[{
                  n: '#1',
                  title: 'Simulaciones y escenarios reales',
                  desc: 'Practica con situaciones visuales antes de enfrentarte a trabajos reales.',
                  value: '$47',
                  image: 'https://cdn.magicpatterns.com/uploads/dYfirGyFUsjJM5t889D4Vt/ChatGPT_Image_6_may_2026,_07_34_32_p.m..png'
                }, {
                  n: '#2',
                  title: 'Diagramas industriales adicionales',
                  desc: 'Más ejemplos para seguir entendiendo controles eléctricos paso a paso.',
                  value: '$37',
                  image: 'https://cdn.magicpatterns.com/uploads/4pDoMjcjvE6kU3iz4cgi32/ChatGPT_Image_6_may_2026,_07_36_00_p.m..png'
                }, {
                  n: '#3',
                  title: 'Biblioteca extra de conexiones eléctricas',
                  desc: 'Material adicional para estudiar conexiones, componentes y sistemas.',
                  value: '$27',
                  image: 'https://cdn.magicpatterns.com/uploads/3v5ztL7xKJ7Rma4ZtvPVAX/ChatGPT_Image_6_may_2026,_07_37_58_p.m..png'
                }, {
                  n: '#4',
                  title: 'Actualizaciones futuras',
                  desc: 'A medida que el sistema se actualice, podrás recibir nuevo contenido y mejoras.',
                  value: '$67',
                  image: 'https://cdn.magicpatterns.com/uploads/baFHmb6A1Muo6yp3g68Xo8/ChatGPT_Image_6_may_2026,_02_54_54_p.m..png'
                }].map((item: any, i) => <li key={i} className="bg-white border border-[#F0EBE0] rounded-2xl p-5 md:p-7 shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-551">
                      {/* Product image - large, centered, top */}
                      {item.image && <div className="flex justify-center mb-5" data-id="element-552">
                          <img src={item.image} alt={item.title} className="w-full max-w-[320px] md:max-w-[380px] rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.18)]" loading="lazy" data-id="element-553" />
                        </div>}

                      {/* Bonus highlighted tag */}
                      <div className="mb-4" data-id="element-554">
                        <span className="inline-block bg-[#FEF3A7] text-gray-900 font-bold text-[15px] md:text-[17px] px-3 py-1.5 rounded-md font-[Poppins,_sans-serif]" data-id="element-555">
                          Bono {item.n}
                        </span>
                      </div>

                      {/* Big title */}
                      <h4 className="text-gray-900 font-black text-[24px] md:text-[32px] leading-[1.15] mb-4 font-[Poppins,_sans-serif] tracking-tight" data-id="element-556">
                        {item.title}
                      </h4>

                      {/* Description */}
                      <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-4" data-id="element-557">
                        {item.desc}
                      </p>

                      {/* Value pill */}
                      <div className="inline-flex items-center gap-2 bg-[#F0FDF4] border border-[#BBF7D0] rounded-full px-4 py-1.5" data-id="element-558">
                        <span className="text-gray-700 font-semibold text-[13px] md:text-[14px]" data-id="element-559">
                          Valor:
                        </span>
                        <span className="text-[#16A34A] font-black text-[15px] md:text-[16px]" data-id="element-560">
                          {item.value}
                        </span>
                      </div>
                    </li>)}
                </ul>

                {/* PRICE REVEAL — Ted's Woodworking style */}
                <div className="text-center mb-3" data-id="element-561">
                  <h3 className="text-gray-900 font-black text-[22px] md:text-[28px] leading-tight font-[Poppins,_sans-serif]" data-id="element-562">
                    Haz Click En El Botón 'Comprar Ahora'
                    <br data-id="element-563" />
                    Para Empezar:
                  </h3>
                </div>

                <div className="bg-[#FFFBE6] border-[3px] border-dashed border-[#DC2626] rounded-lg p-5 md:p-7 text-center" data-id="element-564">
                  {/* Today's price */}
                  <p className="text-[#16A34A] font-black text-[26px] md:text-[34px] uppercase tracking-tight mb-5 font-[Poppins,_sans-serif]" data-id="element-565">
                    PRECIO DE HOY: $14.99
                  </p>

                  {/* Big orange "Add To Cart" button */}
                  <button onClick={goToCheckout} type="button" className="ted-cta-button w-full text-white font-black py-6 md:py-8 px-6 rounded-md cursor-pointer mb-5 border-[3px] border-[#B91C1C]" style={{
                  background: 'linear-gradient(180deg, #FFA94D 0%, #F5720E 50%, #D9580B 100%)',
                  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4), 0 4px 0 #B91C1C, 0 8px 20px rgba(245,114,14,0.35)',
                  textShadow: '0 2px 4px rgba(0,0,0,0.25)'
                }} data-id="element-566">
                    <span className="text-[28px] md:text-[40px] uppercase tracking-wide font-[Poppins,_sans-serif] leading-none" data-id="element-567">
                      Comprar Ahora
                    </span>
                  </button>

                  {/* Secondary link */}
                  <button onClick={goToCheckoutNoTrack} type="button" className="text-[#1E40AF] font-black text-[16px] md:text-[20px] underline decoration-2 underline-offset-4 leading-tight font-[Poppins,_sans-serif] uppercase hover:text-[#1E3A8A] transition-colors mb-5 block mx-auto" data-id="element-568">
                    Empieza A Dominar Los
                    <br data-id="element-569" />
                    Controles Eléctricos Hoy »
                  </button>

                  {/* Payment badges */}
                  <div className="flex items-center justify-center gap-2 md:gap-3 mb-4 flex-wrap" data-id="element-570">
                    {/* VISA */}
                    <div className="bg-white border border-gray-200 rounded-md px-3 py-2 shadow-sm flex items-center justify-center w-[60px] h-[36px] md:w-[68px] md:h-[40px]" data-id="element-571">
                      <span className="text-[#1A1F71] font-black text-[14px] md:text-[16px] italic tracking-tight font-[Arial,_sans-serif]" data-id="element-572">
                        VISA
                      </span>
                    </div>
                    {/* Mastercard */}
                    <div className="bg-white border border-gray-200 rounded-md px-3 py-2 shadow-sm flex items-center justify-center w-[60px] h-[36px] md:w-[68px] md:h-[40px] gap-0" data-id="element-573">
                      <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#EB001B] -mr-2" data-id="element-574"></div>
                      <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#F79E1B] mix-blend-multiply" data-id="element-575"></div>
                    </div>
                    {/* AMEX */}
                    <div className="bg-[#2E77BB] border border-gray-200 rounded-md px-2 py-2 shadow-sm flex items-center justify-center w-[60px] h-[36px] md:w-[68px] md:h-[40px]" data-id="element-576">
                      <span className="text-white font-black text-[10px] md:text-[11px] tracking-tight font-[Arial,_sans-serif]" data-id="element-577">
                        AMEX
                      </span>
                    </div>
                    {/* PayPal */}
                    <div className="bg-white border border-gray-200 rounded-md px-3 py-2 shadow-sm flex items-center justify-center w-[60px] h-[36px] md:w-[68px] md:h-[40px]" data-id="element-578">
                      <span className="font-black text-[12px] md:text-[14px] italic font-[Arial,_sans-serif]" data-id="element-579">
                        <span className="text-[#003087]" data-id="element-580">Pay</span>
                        <span className="text-[#0070BA]" data-id="element-581">Pal</span>
                      </span>
                    </div>
                  </div>

                  {/* One-time purchase disclaimer */}
                  <p className="text-gray-700 text-[14px] md:text-[16px] leading-snug font-[Poppins,_sans-serif]" data-id="element-582">
                    Esta es una compra única.
                    <br data-id="element-583" />
                    NO hay cuotas mensuales.
                  </p>
                </div>
              </div>

              {/* === ACTUALIZACIONES DE POR VIDA === */}
              <div className="border border-[#F0EBE0] rounded-2xl p-5 md:p-8 shadow-[0_2px_16px_rgba(0,0,0,0.04)] bg-[#FEFDFD]" data-id="element-584">
                {/* Membership card image */}
                <div className="flex justify-center mb-6" data-id="element-585">
                  <img src="https://cdn.magicpatterns.com/uploads/qSgVscg7XM3yEbYVjd8mHo/img-diploma-instalador-electricista-768x543-1.png_(1).webp" alt="Actualizaciones de por vida - Tarjeta de membresía" className="w-full max-w-md rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)]" loading="lazy" data-id="element-586" />
                </div>

                {/* Title */}
                <h3 className="text-gray-900 font-black text-[24px] md:text-[34px] leading-tight mb-5 font-[Poppins,_sans-serif] tracking-tight" data-id="element-587">
                  Certificado Profesional Reconocido
                </h3>

                {/* Body */}
                <div className="space-y-4 text-gray-800 text-[15px] md:text-[17px] leading-relaxed" data-id="element-588">
                  <p data-id="element-589">
                    Al completar la guía, recibirás un Certificado Digital
                    Profesional avalado por una empresa del sector eléctrico.
                  </p>
                </div>
              </div>
            </div>

            {/* Identification Heading */}

            {/* Video Testimonials (Luis Ramírez & Francisco Javier) */}
            <div className="w-full max-w-md mx-auto px-2 mb-4 text-center" data-id="element-590">
              <p className="text-[#F5720E] text-[12px] md:text-[14px] uppercase tracking-[0.25em] font-black mb-2 font-[Poppins,_sans-serif]" data-id="element-591">
                Historias reales
              </p>
              <h3 className="text-gray-900 font-black text-[24px] md:text-[32px] leading-[1.15] font-[Poppins,_sans-serif] uppercase tracking-tight" data-id="element-592">
                Lo que dicen los electricistas que ya están usando este sistema
              </h3>
              <p className="text-gray-600 text-[14px] md:text-[16px] mt-2 italic" data-id="element-593">
                Mira sus testimonios en video 👇
              </p>
            </div>
            <div className="flex flex-col gap-4 mb-6 w-full max-w-md mx-auto px-2" data-id="element-594">
              {/* Video 1 - Luis Ramírez */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center pt-[15px] pb-[15px]" data-id="element-595">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-596">
                  <video src="https://cdn.magicpatterns.com/uploads/9i11Vjyfiyk1yw5VqYEhgN/undefined - Imgur (1).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="metadata" data-id="element-597" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-598">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-599" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-600">
                  Luis Ramírez
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-601">
                  Técnico Electricista
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-602">
                  "Ahora puedo realizar mis propios proyectos sin depender de
                  nadie y ganar más."
                </p>
              </div>

              {/* Video 2 - Francisco Javier */}
              <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-4 flex flex-col items-center text-center" data-id="element-603">
                <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-3 bg-black" data-id="element-604">
                  <video src="https://cdn.magicpatterns.com/uploads/wnbQ9Bgc4WFeND59VotTcs/undefined - Imgur (2).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="metadata" data-id="element-605" />
                </div>
                <div className="flex gap-1 mb-2" data-id="element-606">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-607" />)}
                </div>
                <h4 className="text-[20px] font-bold text-gray-900 mb-0.5" data-id="element-608">
                  Francisco Javier
                </h4>
                <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-2" data-id="element-609">
                  Electricista Independiente
                </p>
                <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-610">
                  "Este sistema me dio la confianza para tomar trabajos que
                  antes rechazaba."
                </p>
              </div>

              {/* Amazon-Style Reviews Section - moved below Francisco Javier */}
              <AmazonReviewsSection data-id="element-611" />
            </div>

            {/* Product Mockup Image */}
            <div className="flex justify-center mb-4" data-id="element-612"></div>

            {/* Identification Card */}

            {/* === MOVED: Investment Reframe Box (caja de oferta validada) === */}
            <div className="max-w-lg mx-auto mt-2 mb-4" data-id="element-613"></div>

            {/* === MOVED: OFERTA PROMOCIONAL (caja del producto y precio) === */}
            <div className="max-w-4xl mx-auto py-4" data-id="element-614">
              <div id="oferta-conviccion" className="bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.15)] overflow-hidden" data-id="element-615">
                <div className="flex flex-col md:flex-row" data-id="element-616">
                  {/* LEFT: Ted's Woodworking Style Offer Stack */}
                  <div className="md:w-1/2 p-5 md:p-8 bg-white" data-id="element-617">
                    {/* Headline */}
                    <h3 className="text-[28px] md:text-[36px] leading-[1.05] mb-5 font-[Poppins,_sans-serif] tracking-tight font-[800] text-[#565151]" data-id="element-618">
                      Esto es todo lo
                      <br data-id="element-619" />
                      que recibes hoy:
                    </h3>

                    {/* Product Image */}
                    <div className="mb-6" data-id="element-620">
                      <img src="https://cdn.magicpatterns.com/uploads/gpQcdGR9pb7tp62jigKpwF/8PXa8N2.png" alt="Sistema completo de Comandos Eléctricos - Todos los bonos incluidos" className="w-full" loading="lazy" data-id="element-621" />
                    </div>

                    {/* Main Inclusions - Green checks */}
                    <ul className="space-y-5 mb-7" data-id="element-622">
                      {[{
                      title: 'Acceso Inmediato a +370 Diagramas Eléctricos',
                      desc: 'con explicaciones paso a paso, conexiones reales y sistemas listos para aplicar en campo…',
                      value: '$97 Valor'
                    }, {
                      title: 'Acceso de Por Vida',
                      desc: '— Estudia el material desde tu celular, tablet o computadora cuando quieras, sin cuotas mensuales.',
                      value: '$47 Valor'
                    }, {
                      title: 'Diagramas de Fuerza y Control',
                      desc: '— Aprende a separar lo que muchos confunden y entiende la lógica real detrás de cada sistema',
                      value: '$47 Valor'
                    }, {
                      title: 'Conexiones Realistas Industriales',
                      desc: '— Contactores, relés, temporizadores, motores trifásicos y monofásicos aplicados a trabajos reales',
                      value: '$37 Valor'
                    }, {
                      title: 'Certificado Digital Profesional',
                      desc: 'avalado por una empresa del sector eléctrico al completar la guía',
                      value: '$67 Valor'
                    }, {
                      title: 'Garantía Blindada de 7 Días',
                      desc: '— Si no es para ti, te devolvemos el 100% de tu dinero. Sin preguntas.'
                    }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-623">
                          <Check className="w-7 h-7 text-[#22C55E] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-624" />
                          <p className="text-[#111111] text-[16px] md:text-[17px] leading-[1.55] font-[Poppins,_sans-serif]" data-id="element-625">
                            <strong className="font-black" data-id="element-626">{item.title}</strong>
                            {item.desc && <span className="font-normal" data-id="element-627"> {item.desc}</span>}
                            {item.value && <>
                                {' '}
                                <strong className="text-[#DC2626] font-black" data-id="element-628">
                                  ({item.value})
                                </strong>
                              </>}
                          </p>
                        </li>)}
                    </ul>

                    {/* Plus These Amazing Bonuses */}
                    <h4 className="text-center text-[#111111] font-black italic text-[26px] md:text-[32px] leading-tight mb-5 font-[Poppins,_sans-serif]" data-id="element-629">
                      Más Estos Bonos Increíbles:
                    </h4>

                    <ul className="space-y-4 mb-7" data-id="element-630">
                      {[{
                      title: 'Simulaciones y Escenarios Reales',
                      value: '$47 Valor'
                    }, {
                      title: 'Diagramas Industriales Adicionales',
                      value: '$37 Valor'
                    }, {
                      title: 'Biblioteca Extra de Conexiones Eléctricas',
                      value: '$27 Valor'
                    }, {
                      title: 'Actualizaciones Futuras Gratis',
                      value: '$67 Valor'
                    }].map((b, i) => <li key={i} className="flex items-start gap-3" data-id="element-631">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#F5720E] text-white font-black text-[18px] flex items-center justify-center mt-0.5 leading-none" data-id="element-632">
                            +
                          </span>
                          <p className="text-[#111111] text-[16px] md:text-[17px] leading-[1.55] font-[Poppins,_sans-serif]" data-id="element-633">
                            <strong className="font-black" data-id="element-634">{b.title}</strong>{' '}
                            <strong className="text-[#DC2626] font-black" data-id="element-635">
                              ({b.value})
                            </strong>
                          </p>
                        </li>)}
                    </ul>

                    {/* Total Value */}
                    <div className="text-center mb-2" data-id="element-636">
                      <p className="text-[#DC2626] font-black italic text-[26px] md:text-[32px] underline decoration-2 underline-offset-4 font-[Poppins,_sans-serif] leading-tight" data-id="element-637">
                        Valor Total: $329
                      </p>
                    </div>

                    {/* Get Started Today */}
                    <div className="text-center mb-1 mt-5" data-id="element-638">
                      <p className="text-[#111111] font-black text-[20px] md:text-[24px] font-[Poppins,_sans-serif]" data-id="element-639">
                        Hoy Lo Obtienes Por Solo:
                      </p>
                    </div>

                    {/* Big Price */}
                    <div className="text-center mb-3" data-id="element-640">
                      <p className="text-[#16A34A] font-black text-[64px] md:text-[80px] underline decoration-[3px] underline-offset-[8px] font-[Poppins,_sans-serif] leading-none" data-id="element-641">
                        $14.99
                      </p>
                    </div>

                    {/* Disclaimer */}
                    <p className="text-center text-[#111111] font-bold text-[14px] md:text-[15px] leading-[1.55] mb-2 font-[Poppins,_sans-serif] italic" data-id="element-642">
                      (Esta es una oferta de lanzamiento especial, me reservo el
                      derecho de terminar este descuento en cualquier momento)
                    </p>
                  </div>

                  {/* RIGHT: Sales Content */}
                  <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center" data-id="element-643">
                    <button id="cta-comprar-1clic" onClick={goToCheckout} type="button" className="ted-cta-button w-full text-white font-black py-5 md:py-6 px-6 rounded-md mb-4 cursor-pointer border-[3px] border-[#B91C1C] flex flex-col items-center gap-1" style={{
                    background: 'linear-gradient(180deg, #FFA94D 0%, #F5720E 50%, #D9580B 100%)',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4), 0 4px 0 #B91C1C, 0 8px 20px rgba(245,114,14,0.35)',
                    textShadow: '0 2px 4px rgba(0,0,0,0.25)'
                  }} data-id="element-644">
                      <span className="text-[20px] md:text-[24px] uppercase tracking-wide" data-id="element-645">
                        SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
                      </span>
                      <span className="text-[12px] md:text-[13px] font-semibold opacity-90" data-id="element-646">
                        Acceso Inmediato • Garantía de 7 Días
                      </span>
                    </button>

                    <div className="mb-2" data-id="element-647">
                      <UrgencyCountdown data-id="element-648" />
                    </div>

                    <p className="text-[#6b7280] text-xs text-center mb-3" data-id="element-649">
                      Acceso inmediato • Pago único • Sin suscripciones
                    </p>

                    <div className="flex justify-center" data-id="element-650">
                      <img src="https://cdn.magicpatterns.com/uploads/p6qxTwGmZgbzY9XkZUWTq8/Trust-badges.webp" alt="Guaranteed Safe Checkout" className="max-w-[240px] w-full opacity-80" loading="lazy" data-id="element-651" />
                    </div>
                  </div>
                </div>
              </div>

              <GuaranteeDropdown data-id="element-652" />
            </div>
          </div>
        </section>
      </LazySection>

      {/* VIDEO TESTIMONIALS + FRUSTRATION METHOD */}
      <LazySection data-id="element-653"></LazySection>

      {/* HERO SECTION */}
      <LazySection data-id="element-654">
        <section className="px-4 bg-[#FFFBEB] py-1 mt-0 mb-0" data-id="element-655">
          <div className="max-w-2xl mx-auto" data-id="element-656">
            <div className="flex justify-center mt-1" data-id="element-657">
              <img src="https://cdn.magicpatterns.com/uploads/1Ma4sTrAHUAYdaEPN8LkAw/30-day-money-back-guarantee-260nw-2631258675.webp" alt="Garantía de devolución de dinero - 7, 10, 15 y 30 días" className="max-w-[200px] w-full opacity-70" loading="lazy" style={{
              mixBlendMode: 'multiply'
            }} data-id="element-658" />
            </div>
            {/* GIF */}
            <div className="flex justify-center mt-2" data-id="element-659"></div>
          </div>
        </section>
      </LazySection>

      {/* GUARANTEE BADGE */}
      <LazySection data-id="element-660">
        <section className="py-6 px-4 bg-[#FFFBEB]" data-id="element-661">
          <div className="max-w-lg mx-auto" data-id="element-662">
            <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-6 md:p-8 text-center" data-id="element-663">
              {/* Badge Circle */}
              <div className="mx-auto mb-4 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-664">
                <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-665">
                  7
                </span>
                <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-666">
                  Días
                </span>
                <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-667">
                  Garantía
                </span>
              </div>

              {/* Title */}
              <h3 className="md:text-2xl font-black text-gray-900 mb-3 text-[24px] font-[Inter,_sans-serif]" data-id="element-668">
                Pruebalo durante 7 dias
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-669">
                No quiero tu dinero si este manual no transforma tu cocina. Por
                eso te doy mi{' '}
                <span className="font-bold text-gray-900" data-id="element-670">
                  Garantía Blindada de 7 Días
                </span>
                .
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-3" data-id="element-671">
                Si sentís que no es para vos, nos enviás un correo y te
                devolvemos el{' '}
                <span className="font-bold text-gray-900" data-id="element-672">
                  100% de tu inversión
                </span>
                . Sin preguntas, sin vueltas.
              </p>

              {/* Closing line */}
              <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-673">
                — El riesgo es todo nuestro.
              </p>
            </div>
          </div>
        </section>
      </LazySection>

      <LazySection data-id="element-674">
        <AboutAuthorSection data-id="element-675" />
      </LazySection>

      <LazySection data-id="element-676">
        <FAQSection data-id="element-677" />
      </LazySection>

      {/* URGENCY & FINAL CLOSE */}
      <LazySection data-id="element-678">
        <div className="py-6 px-4 bg-[#0F1827] text-center" data-id="element-679">
          <div className="max-w-md mx-auto" data-id="element-680">
            <p className="text-white md:text-lg font-bold mb-3 text-[14px]" data-id="element-681">
              No dejes pasar esta oportunidad
            </p>
            <button onClick={goToCheckoutNoTrack} className="green-cta-impact w-full text-white py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55F] font-[900] font-[Inter,_sans-serif] flex flex-col items-center gap-1" data-id="element-682">
              <span className="text-[20px] md:text-[22px] uppercase tracking-wide" data-id="element-683">
                SÍ, QUIERO GANAR MÁS COMO ELECTRICISTA
              </span>
              <span className="text-[13px] md:text-[14px] font-semibold opacity-90" data-id="element-684">
                Acceso Inmediato • Garantía de 7 Días
              </span>
            </button>
            <p className="text-gray-500 text-xs mt-2 tracking-wide" data-id="element-685">
              Acceso inmediato • Sin pagos mensuales • Empiezas en segundos
            </p>
          </div>
        </div>
      </LazySection>

      {/* Floating CTA Button */}
      <FloatingCTA data-id="element-686" />

      {/* Footer */}
      <LazySection data-id="element-687">
        <footer className="bg-[#0F1827] py-5 px-4 text-center" data-id="element-688">
          <p className="text-gray-400 text-sm" data-id="element-689">
            📧 Contacto:{' '}
            <a href="mailto:apoyocomunidadelectrica@gmail.com" className="text-[#F7D060] hover:underline font-medium" data-id="element-690">
              apoyocomunidadelectrica@gmail.com
            </a>
          </p>
          <p className="text-gray-500 text-xs mt-2" data-id="element-691">
            © {new Date().getFullYear()} Comunidad Eléctrica. Todos los
            derechos reservados.
          </p>
        </footer>
      </LazySection>
    </div>;
}